import styled from "styled-components";

export const ModalOverlay = styled.div`
    background: #00000089;
    position: fixed;
    height: 100%;
    width: 100%;
    display: ${(props) => props.open ? "flex" : "none"};
    justify-content: center;
    align-items: center;
    top: 0;
    z-index: 1;
    overflow: hidden;
`;

export const ModalContainer = styled.div`
    display: ${(props) => props.open ? "flex" : "none"};
    position: fixed;
    z-index: 2;
    width: 50%;
    height: 100vh;
    display: flex;
    justify-content: right;
    align-items: center;
    top: 10px;
    right: 0px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const Container = styled.div`
    background: #fff;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
    height: 103vh;
    width: 60%;
    overflow: auto;
    @media (max-width: 1285px) {
        width: 65%;
    }
    @media (max-width: 1010px) {
        width: 70%;
    }
    @media (max-width: 768px) {
        width: 100%;
    }
    &::-webkit-scrollbar{
        /* display: none; */
    }
`;

export const ModalContent = styled.div`
    position: absolute;
    z-index: 1;;
    width: 60%;
    height: 101vh;
    overflow: auto;

    @media (max-width: 1285px) {
        width: 65%;
    }
    @media (max-width: 1010px) {
        width: 70%;
    }
    @media (max-width: 768px) {
        width: 100%;
    }
`

export const OverlayLoading = styled.div`
  height: 100vh;
  position: relative;
  display: ${(props) => props?.loading ? "flex" : "none"};
  z-index: 4;
  background: #00000033;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;
    align-items: center;
    margin-top: 10px;
`;

export const Title = styled.p`
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 600;
`;

export const Icon = styled.img`
    width: 20px;
    cursor: pointer;
`;

export const FInputWrapper = styled.div`
  width: 85%;
  padding: 10px;
`;
export const FSelectWrapper = styled.div`
  width: 95%;
  padding: 10px;
  @media (max-width: 768px) {
    width: 89%;
  }
`;

export const FFile = styled.input`
  display: none;
`;

export const FInput = styled.input`
  width: 100%;
  height: 20px;
  padding: 10px 16px;
  border-radius: 8px;
  background: var(--Color-Primitive-Neutral-neutral-100, #F5F5F5);
  border: 1px solid ${({ error }) => (error ? "#DC2626" : "#E5E7EB")};
  &:focus {
    outline: none;
    border-color: ${({ error }) => (error ? "#DC2626" : "#3B82F6")};
    box-shadow: ${({ error }) =>
    error ? "0 0 0 2px rgba(220, 38, 38, 0.5)" : "0 0 0 2px rgba(59, 130, 246, 0.5)"};
  }

`;

export const FSelect = styled.select`
  width: 100%;
  /* padding: 12px; */
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  outline: none;
  background: var(--Color-Primitive-Neutral-neutral-100, #F5F5F5);
  &:focus {
    border-color: #007bff;
  }
`;


export const FInputArea = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 10px 16px 10px 16px;
  border-radius: 8px;
  background: var(--Color-Primitive-Neutral-neutral-100, #F5F5F5);
  border: 1px solid ${({ error }) => (error ? "#DC2626" : "#E5E7EB")};
  &:focus {
    outline: none;
    border-color: ${({ error }) => (error ? "#DC2626" : "#3B82F6")};
    box-shadow: ${({ error }) =>
    error ? "0 0 0 2px rgba(220, 38, 38, 0.5)" : "0 0 0 2px rgba(59, 130, 246, 0.5)"};
  }
`;

export const ErrorMessage = styled.div`
  color: #dc2626;
  font-size: 12px;
  font-weight: 500;
  padding: 10px;
  padding-top: 5px;
`;

export const ButtonContainer = styled.div`
    padding: 10px;
    margin-bottom: 50px;
`;

export const Button = styled.button`
    border-radius: 30px;
    width: 100%;
    color: black;
    min-height: 40px;
    color: var(--white);
    background-color: var(--primary-color);
    text-decoration: none;
    text-align: center;
`;

export const TaskContainer = styled.div`
  width: 100%;
  padding: 0px;
`;


export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin: 10px;
  padding: 10px;
  border-radius: 12px;
  /* margin-bottom: 12px; */

  &.diproses{
    background-color: #fff8e1;
  }
  &.selesai{
    background-color: #e8f5e9;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 100%;
`;

export const TitleTugas = styled.div`
  font-weight: bold;
  font-size: 18px;
  color: #333;
`;

export const Description = styled.div`
  font-size: 14px;
  color: #666;
  margin-top: 4px;
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ButtonEdit = styled.button`
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  background-color: #ffc107;
  color: #333;
`;
export const ButtonDelete = styled.button`
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  background-color: #dc3545;
  color: white;
`;


export const TugasContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  padding: 16px;
  background-color: #ebebf2;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  max-width: 100%;
`;

export const FormTugas = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  flex: 1;
  min-width: 100px;
`;

export const SelectTugas = styled.select`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  flex: 1;
  min-width: 100px;
`;

export const SearchTugas = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  flex: 1;
  min-width: 100px;
`;

export const TombolTambahTugas = styled.button`
  background-color: #ffc107;
  color: #333;
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e0a800;
  }
`;

export const ContentTask = styled.div`
  padding: 10px;
`;

export const TitleTask = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const DescriptionTask = styled.p`
  font-size: 16px;
  margin-bottom: 16px;
  color: #333;
`;

export const ImageContainer = styled.div`
  border: 1px dashed #ccc;
  padding: 10px;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  background: #fff;
`;


export const Image = styled.img`
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
`

export const StatusContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const Status = styled.div`
  font-weight: bold;
  border-radius: 6px;
  width: fit-content;
  &.selesai{
    background-color: #66bb6a;
    color: #fff;
    padding: 10px;
  }
`;

export const ButtonStatus = styled.div`
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;

  &.baru{
    background-color: #fdd835;
    color: #000;
  }

  &.diproses{
    background-color: #66bb6a;
    color: #fff;
  }

  &:hover{
    opacity: 0.9;
  }
`;